import React from 'react'

export const Footer = () => {
  return (
    <div className='flex flex-col justify-between gap-2 items-center w-full py-4 text-white text-center text-xs font-light bg-stone-400 dark:bg-stone-800'>
        <div>
          Developed by @notalepower<br/>
        </div>
    </div>
  )
}
